export const YOUTUBE_OVERVIEW_MULTI_BRAND = [
  { h: 1, type: 'HEADER', w: 6, x: 0, y: 0, meta: { name: 'All Published Posts' } },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['SUBSCRIBERS_TOTAL'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['SUBSCRIBERS_NET_NEW'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 5,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['AVG_VIEW_DURATION'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 5,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['ENGAGEMENTS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 9,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['ESTIMATED_SECONDS_WATCHED'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 9,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['VIEWS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 13,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['SUBSCRIBERS_NET_NEW'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 13,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['AVG_VIEW_DURATION'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['VIEWS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['ENGAGEMENTS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 41,
    meta: { name: 'Video Performance ' },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 42,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_VIDEO_VIEWS'],
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 46,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_VIDEO_VIEWS'],
      sort_order: 'ASC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 20,
    meta: { name: 'Posts Published During Reporting Period' },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 21,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_VIDEO_VIEWS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 21,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_AVG_VIEW_DURATION'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 25,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_AVG_VIEW_PERCENTAGE'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 25,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_ESTIMATED_SECONDS_WATCHED'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 29,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_ENGAGEMENTS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 29,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_LIKES'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 33,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_DISLIKES'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 33,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_COMMENTS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 37,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_SHARES'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 37,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_VIDEOS_ADDED_TO_PLAYLIST'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
];
